export const CARE_TYPES = [
  'Domiciliary Care',
  'Respite Care',
  'Dementia Care',
  'Post-Hospital Care',
  'Elderly Care',
  'Palliative Care',
  'Disability Care',
  'Companionship Care',
  'Live-in Care',
  'Night Care',
  'Child Care',
  'Nursing Home Care/ Care Home Stay',
  'Nursing Care',
  'Hospital Stay Companion'
] as const;

export const BUSINESS_TYPES = [
  'Individual Provider',
  'Care Agency',
  'Care Home',
  'Nursing Home',
  'Supported Living'
] as const;

export const RELATIONSHIP_OPTIONS = [
  'Daughter',
  'Son',
  'Spouse/Partner',
  'Sibling',
  'Friend',
  'Professional Carer',
  'Other'
] as const;

export const HOUSE_TYPE_OPTIONS = [
  'Apartment',
  'House',
  'Villa',
  'Bungalow',
  'Flat',
  'Townhouse',
  'Cottage',
  'Other'
] as const;

export const BOOKING_FOR_OPTIONS = [
  'Self',
  'Father',
  'Mother',
  'Spouse',
  'Grandparent',
  'Sibling',
  'Friend',
  'Other Family Member',
  'Other'
] as const;

export const MENTAL_CONDITION_OPTIONS = [
  'Normal',
  'Dementia',
  'Alzheimer\'s',
  'Depression',
  'Anxiety',
  'Bipolar Disorder',
  'Schizophrenia',
  'PTSD',
  'Other'
] as const;

export const CARE_SHIFT_OPTIONS = [
  'Day',
  'Night',
  'Full-time',
  'Part-time',
  'Live-in'
] as const;

export const CARE_FREQUENCY_OPTIONS = [
  'Daily',
  'Weekly',
  'Bi-weekly',
  'Monthly',
  'As-needed',
  'Occasional'
] as const;

export const CAREGIVER_GENDER_OPTIONS = [
  'Male',
  'Female',
  'No preference'
] as const;

export const GENDER_OPTIONS = [
  'Male',
  'Female',
  'Other'
] as const;

export const MOBILITY_OPTIONS = [
  'Independent',
  'Needs support',
  'Walker',
  'Wheelchair',
  'Bedridden'
] as const;

export const ROUTES = {
  HOME: '/',
  HOME_PAGE: '/home',
  LOGIN: '/login',
  REGISTER: '/register',
  VERIFY_OTP: '/verify-otp',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  ADMIN_LOGIN: '/adminlogin',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_PROVIDER_DETAILS: '/admin/provider',
  ADMIN_REVIEWS: '/admin/reviews',
  ADMIN_BOOKINGS: '/admin/bookings',
  ADMIN_DELETE_REQUESTS: '/admin/delete-requests',
  DASHBOARD: '/dashboard',
  PROVIDERS: '/providers',
  FIND_PROVIDERS: '/find-providers',
  SETTINGS: '/settings',
  PROVIDER_PROFILE: '/provider/profile',
  PROVIDER_DETAIL: '/provider/detail',
  MY_BOOKINGS: '/bookings',
  PROVIDER_BOOKINGS: '/provider/bookings',
  MY_POSTS: '/my-posts',
  ALL_POSTS: '/browse-posts',
  MESSAGES: '/messages',
  NOTIFICATIONS: '/notifications',
  ABOUT: '/about',
  HOW_IT_WORKS: '/how-it-works',
  FOR_PROVIDERS: '/for-providers',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
  COOKIE_POLICY: '/cookie-policy',
  CANCELLATION_POLICY: '/cancellation-policy',
  SAFEGUARDING_POLICY: '/safeguarding-policy',
  COMPLAINTS_PROCEDURE: '/complaints-procedure',
  ACCESSIBILITY: '/accessibility'
} as const;

export const API_ENDPOINTS = {
  LOGIN: '/api/auth/login',
  REGISTER: '/api/auth/register',
  LOGOUT: '/api/auth/logout',
  ME: '/api/auth/me',
  REFRESH: '/api/auth/refresh',
  GET_ALL_PROVIDERS: '/api/provider/providers',
  SEARCH_PROVIDERS: '/api/provider/search',
  CREATE_BOOKING: '/api/booking/create',
  ACCEPT_BOOKING: '/api/booking/accept',
  REJECT_BOOKING: '/api/booking/reject',
  CANCEL_BOOKING: '/api/booking/cancel',
  COMPLETE_BOOKING: '/api/booking/complete',
  BOOKING_DETAILS: '/api/booking/details',
  CREATE_POST: '/api/post/create',
  UPDATE_POST: '/api/post/update',
  GET_USER_POSTS: '/api/post/my-posts',
  DELETE_POST: '/api/post/delete',
  GET_ALL_POSTS: '/api/post/all',
  CONTACT_POST: '/api/posts/contact'
} as const;

export const TRUST_BADGES = [
  { text: 'CQC Verified', icon: 'shield-check' },
  { text: 'Secure Payments', icon: 'lock' }
] as const;

export const PROVIDER_MESSAGE_TEMPLATES = [
  "👋 Hi, We are interested in providing care for you.",
  "We are available for your requested care service.",
  "We match your care requirements."
] as const;

export const USER_REPLY_TEMPLATES = [
  "Yes, I'm interested",
  "Tell me more",
  "Not interested"
] as const;
